import type { TFunction } from 'i18next';
import { LogNotification } from '@/api';
import { isDemonstrationStartedSubtype } from './notificationSubtypes';

const MESSAGE_KEYS: Record<string, string> = {
    NOTIFY_GAME_CHALLENGE_DIRECT: 'messages.directChallenge',
    NOTIFY_GAME_CHALLENGE_DIRECT_RANKED: 'messages.rankedChallenge',
    NOTIFY_GAME_CHALLENGE_ACCEPT: 'messages.challengeAccepted',
    NOTIFY_GAME_CHALLENGE_REJECT: 'messages.challengeRejected',
    NOTIFY_BROADCAST_START: 'messages.broadcastStarted',
    NOTIFY_BROADCAST_END: 'messages.broadcastEnded',
    NOTIFY_BROADCAST_INVITE: 'messages.demonstrationInvite',
    NOTIFY_PAYMENT_DONATION: 'messages.donationReceived',
};

const interpolateFallback = (notification: LogNotification) =>
    (notification.messageFallback ?? '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key: string) => {
        const data = notification.messageData ?? {};
        return data[key] ?? data[key.replace('_', '')] ?? '';
    });

export const getNotificationMessage = (notification: LogNotification, t: TFunction) => {
    const subtype =
        notification.game ?? notification.broadcast ?? notification.tournament ?? notification.payment ?? '';
    const key = isDemonstrationStartedSubtype(subtype) ? 'messages.demonstrationStarted' : MESSAGE_KEYS[subtype];
    const userName = notification.messageData?.user_name ?? notification.messageData?.username ?? t('unknownUser');

    return key
        ? t(key, { userName, amount: notification.messageData?.amount ?? '' })
        : interpolateFallback(notification) || t('unknown');
};
